import { render, staticRenderFns } from "./errorDialog.vue?vue&type=template&id=6a309396&scoped=true"
import script from "./errorDialog.vue?vue&type=script&lang=js"
export * from "./errorDialog.vue?vue&type=script&lang=js"
import style0 from "./errorDialog.vue?vue&type=style&index=0&id=6a309396&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a309396",
  null
  
)

export default component.exports